export { default } from "./useValueAsRef.mjs";